 export let VersionNumber = 1226;



// WEBPACK FOOTER //
// ./src/version.ts